<template>
  <div id="alterations">
    <div class="header flex-between">
      <div class="header-text">
        <h1>操作角色定义</h1>
      </div>
      <div class="header-button">
        <el-button
          v-if="jurisdiction.search"
          icon="iconfont icon-sousuo1"
          @click="searchcz"
          >查询</el-button
        >
        <el-button
          v-if="jurisdiction.create"
          icon="iconfont icon-chuangjian1"
          @click="createcz"
          >创建</el-button
        >
        <el-button
          v-if="jurisdiction.modify"
          icon="iconfont icon-xiugai1"
          @click="modifycz"
          >修改</el-button
        >
        <el-button
          v-if="jurisdiction.delete"
          icon="iconfont icon-a-shanchu11"
          @click="Deletecz"
          >删除</el-button
        >
        <el-button
          v-if="jurisdiction.look"
          icon="iconfont icon-chakan1"
          @click="lookcz"
          >查看</el-button
        >
      </div>
    </div>
    <!-- 创建弹窗 -->
    <div class="found">
      <el-dialog
        width="35%"
        title="角色定义—创建"
        :visible.sync="RoledeFormvisible"
        :close-on-click-modal="false"
        @close="createformClosed"
      >
        <div>
          <el-form
            size="mini"
            label-width="100px"
            :model="createForm"
            ref="creatrformRef"
            :rules="createFormRules"
          >
            <el-row>
              <el-col :span="12">
                <el-form-item label="角色编号" prop="roleCode">
                  <div class="flex-start">
                    <el-input style="width: 80%" v-model="createForm.roleCode">
                    </el-input>
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="角色描述" prop="roleName">
                  <div class="flex-start">
                    <el-input style="width: 80%" v-model="createForm.roleName">
                    </el-input>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
            <div class="menutitle">
              <span class="titlewz">菜单功能定义</span>
            </div>
            <el-row>
              <el-col>
                <el-tree
                  :data="treecontrol"
                  show-checkbox
                  default-expand-all
                  node-key="menuID"
                  ref="tree1"
                  highlight-current
                  :props="defaultProps"
                  @check="checkHandler"
                >
                </el-tree>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="createList('creatrformRef')">保 存</el-button>
          <el-button @click="RoledeFormvisible = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 修改弹窗 -->
    <div class="found">
      <el-dialog
        width="35%"
        title="角色定义—修改"
        :visible.sync="ModifyFormvisible"
        :close-on-click-modal="false"
        @close="moifyformClosed"
      >
        <div>
          <el-form
            size="mini"
            label-width="100px"
            :model="moifyczForm"
            ref="moifyformRef"
            :rules="moifyFormRules"
          >
            <el-row>
              <el-col :span="12">
                <el-form-item label="角色编号" prop="roleCode">
                  <div class="flex-start">
                    <el-input style="width: 80%" v-model="moifyczForm.roleCode">
                    </el-input>
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="角色描述" prop="roleName">
                  <div class="flex-start">
                    <el-input style="width: 80%" v-model="moifyczForm.roleName">
                    </el-input>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
            <div class="menutitle">
              <span class="titlewz">菜单功能定义</span>
            </div>
            <el-row>
              <el-col>
                <el-tree
                  :data="modifytree"
                  show-checkbox
                  default-expand-all
                  node-key="id"
                  ref="tree"
                  highlight-current
                  :props="modiyfdefaultProps"
                  :default-checked-keys="xgxuanzhong"
                  @check="checkHandler"
                >
                </el-tree>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="modifyList('moifyformRef')">保 存</el-button>
          <el-button @click="ModifyFormvisible = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 删除弹窗 -->
    <div class="delete">
      <el-dialog
        width="20%"
        title="删除操作角色定义表确认取消对话框"
        :visible.sync="deleteFormVisible"
        :close-on-click-modal="false"
      >
        <div style="height: 50px; font-size: 14px; font-weight: 700">
          <p>
            <i
              class="iconfont icon-jingshi"
              style="font-size: 28px; color: #f39b21"
            ></i>
            是否真的要<span style="color: #ff0000">删除</span>操作角色定义表?
          </p>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="deleteczqd">确 定</el-button>
          <el-button @click="deleteFormVisible = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 查看弹窗 -->
    <div class="look">
      <el-dialog
        width="35%"
        title="角色定义—查看"
        :visible.sync="LookFormvisible"
        :close-on-click-modal="false"
        @close="lookformClosed"
      >
        <div>
          <el-form
            size="mini"
            label-width="100px"
            :model="lookForm"
            ref="lookformRef"
          >
            <el-row>
              <el-col :span="12">
                <el-form-item label="角色编号" prop="roleCode">
                  <div class="flex-start">
                    <el-input
                      disabled
                      style="width: 80%"
                      v-model="lookForm.roleCode"
                    >
                    </el-input>
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="角色描述" prop="roleName">
                  <div class="flex-start">
                    <el-input
                      disabled
                      style="width: 80%"
                      v-model="lookForm.roleName"
                    >
                    </el-input>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
            <div class="menutitle">
              <span class="titlewz">菜单功能定义</span>
            </div>
            <el-row>
              <el-col :span="24">
                <el-tree
                  :data="looktree"
                  show-checkbox
                  default-expand-all
                  node-key="id"
                  ref="tree1"
                  highlight-current
                  :default-checked-keys="xuanzhong"
                  :props="lookdefaultProps"
                >
                </el-tree>
              </el-col>
            </el-row>
            <el-divider></el-divider>
            <el-row>
              <el-col :span="12">
                <el-form-item label="创建人" prop="createUserName">
                  <div class="flex-start">
                    <el-input
                      disabled
                      style="width: 80%"
                      v-model="lookForm.createUserName"
                    >
                    </el-input>
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="创建时间" prop="createTime">
                  <el-date-picker
                    style="width: 90%"
                    :disabled="true"
                    v-model="lookForm.createTime"
                    type="datetime"
                    value-format="yyyy-MM-dd HH:mm:ss"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="最后修改人" prop="updateUserName">
                  <div class="flex-start">
                    <el-input
                      disabled
                      style="width: 80%"
                      v-model="lookForm.updateUserName"
                    >
                    </el-input>
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="最后修改时间" prop="updateTime">
                  <el-date-picker
                    style="width: 90%"
                    :disabled="true"
                    v-model="lookForm.updateTime"
                    type="datetime"
                    value-format="yyyy-MM-dd HH:mm:ss"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="LookFormvisible = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 首页列表查询卡片 -->
    <el-card shadow="never">
      <div class="searchform">
        <el-form label-width="100px" :model="queryInfo" size="small">
          <el-row :gutter="50">
            <el-col :span="12">
              <el-form-item label="角色编号">
                <el-input
                  style="width: 50%"
                  v-model="queryInfo.roleCode"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="角色描述">
                <el-input
                  style="width: 50%"
                  v-model="queryInfo.roleName"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="创建日期从">
                <el-date-picker
                  style="width: 50%"
                  v-model="queryInfo.datePicker"
                  type="daterange"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :picker-options="pickerOptions"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-card>
    <!-- 首页列表表格内容 -->
    <div>
      <el-card shadow="never" class="centercard">
        <el-table
          size="small"
          :height="isMore ? 'calc(100vh - 26.5rem)' : 'calc(100vh - 24rem)'"
          class="table-style"
          border
          :row-class-name="tableRowClassName"
          :header-cell-style="{
            background: '#FCFBF2',
            color: '#6C6839',
            'text-align': 'center',
            fontSize: '14px',
          }"
          :cell-style="{ 'text-align': 'center' }"
          ref="multipleTable"
          :data="ActionroleList"
          tooltip-effect="dark"
          v-el-table-infinite-scroll="load"
          v-loading="loading"
          infinite-scroll-disabled="onLoading"
        >
          <!-- <el-table-column type="selection" width="45"> </el-table-column> -->
          <el-table-column width="40">
            <template slot-scope="scope">
              <el-radio
                :label="scope.$index"
                v-model="radio"
                @change="ActionroleRadioChange(scope.row)"
                >&nbsp;</el-radio
              >
            </template>
          </el-table-column>
          <el-table-column prop="roleCode" label="角色编号"> </el-table-column>
          <el-table-column prop="roleName" label="角色描述"> </el-table-column>
          <el-table-column prop="isValid" label="状态">
            <template slot-scope="scope">
              {{ scope.row.isValid === 0 ? "有效" : "无效" }}
            </template>
          </el-table-column>
          <el-table-column prop="createUserName" label="创建人">
          </el-table-column>
          <el-table-column prop="createTime" label="创建日期">
            <template slot-scope="scope">
              {{ scope.row.createTime | dateFormat }}
            </template>
          </el-table-column>
          <el-table-column prop="updateUserName" label="最后修改人">
          </el-table-column>
          <el-table-column prop="updateTime" label="最后修改日期">
            <template slot-scope="scope">
              <div v-if="scope.row.updateTime !== null">
                {{ scope.row.updateTime | dateFormat }}
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-alert
          v-if="isMore"
          title="没有更多啦!"
          type="warning"
          center
          show-icon
          :closable="false"
        >
        </el-alert>
      </el-card>
    </div>
  </div>
</template>

<script>
import {
  SysrolepageApi,
  SysroleinsertOperDefindApi,
  SysroledeleteApi,
  SysrolequeryApi,
  SysroleupdateOperDefindApi,
} from "@/api/user";
import { SysmenugetMenusApi } from "@/api/shop";
import { dateTimes } from "@/utils/auth";
export default {
  name: "alterations",
  data() {
    return {
      jurisdiction: {
        search: false,
        create: false,
        modify: false,
        delext: false,
        look: false,
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一年",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      radio: "",
      // // 搜索请求参数
      // searchlist: {
      //   roleType: "0",
      //   roleCode: "",
      //   roleName: "",
      //   createDateStart: "",
      //   createDateEnd: "",
      //   pageNo: 1,
      //   pageSize: 50,
      // },
      // 首页列表内容
      ActionroleList: [],
      // 首页列表radio选中数据
      radioValueczList: [],
      // 首页列表请求参数
      queryInfo: {
        roleCode: "",
        roleName: "",
        datePicker: "",
        createDateStart: "",
        createDateEnd: "",
        roleType: "0",
        pageNo: 1, //页码
        pageSize: 50, //页数据
        pages: 0, //页总数据
      },
      // 首页loadgin
      loading: false,
      // 创建弹窗
      RoledeFormvisible: false,
      // 修改弹窗
      ModifyFormvisible: false,
      // 创建id请求参数
      treeform: [],
      // labelPosition:"top",
      // 创建弹窗表单验证
      createFormRules: {
        roleCode: [
          { required: true, message: "请输入角色编号", trigger: "blur" },
        ],
        roleName: [
          { required: true, message: "请输入角色描述", trigger: "blur" },
        ],
      },
      xuanzhong: [],
      // 创建弹窗列表
      createForm: {
        roleCode: "", // 角色编号
        roleName: "", // 角色名称
      },
      // 创建弹窗树形列表
      treecontrol: [],
      defaultProps: {
        children: "children",
        label: "menuName",
      },
      // 修改弹窗
      moifyczForm: {
        roleID: "",
        roleCode: "",
        roleName: "",
      },
      moifyczFormcs: {
        roleID: "",
      },
      // 修改弹窗树形列表
      modifytree: [],
      modiyfdefaultProps: {
        children: "children",
        label: "menuName",
      },
      xgxuanzhong: [],
      xgexpandedKeys: [],
      // 修改弹窗表单验证
      moifyFormRules: {
        roleCode: [
          { required: true, message: "请输入角色编号", trigger: "blur" },
        ],
        roleName: [
          { required: true, message: "请输入角色描述", trigger: "blur" },
        ],
      },
      // 删除弹窗
      deleteFormVisible: false,
      // 操作删除delete
      Deleteczid: {
        roleID: "",
      },
      // 查看弹窗
      LookFormvisible: false,
      // 查看弹窗表单
      lookForm: {},
      // 查看弹窗cs
      lookFormcs: {
        roleID: "",
      },
      checkerds: {},
      // 查看弹窗树形列表
      looktree: [],
      lookdefaultProps: {
        children: "children",
        disabled: this.disabledFn,
        label: "menuName",
      },
      // 查看遍历数组保存
      expandedKeys: [],
    };
  },
  created() {
    this.SysrolepageList();
    let RoleDefinition = JSON.parse(localStorage.getItem("RoleDefinition"));
    for (let i = 0; i < RoleDefinition.length; i++) {
      if (RoleDefinition[i].menuName == "查询") {
        this.jurisdiction.search = true;
        continue;
      }
      if (RoleDefinition[i].menuName == "创建") {
        this.jurisdiction.create = true;
        continue;
      }
      if (RoleDefinition[i].menuName == "修改") {
        this.jurisdiction.modify = true;
        continue;
      }
      if (RoleDefinition[i].menuName == "删除") {
        this.jurisdiction.delete = true;
        continue;
      }
      if (RoleDefinition[i].menuName == "查看") {
        this.jurisdiction.look = true;
        continue;
      }
    }
    console.log(RoleDefinition);
  },
  computed: {
    isMore() {
      //当起始页数等于总页数时停止加载
      return this.queryInfo.pageNo >= this.queryInfo.pages;
    },
    onLoading() {
      return this.loading || this.isMore;
    },
  },
  methods: {
    async searchcz() {
      this.queryInfo.pageNo = 1;
      this.radio = "";
      this.radioValueczList = "";
      if (this.queryInfo.datePicker && this.queryInfo.datePicker.length > 0) {
        this.queryInfo.createDateStart = dateTimes(
          this.queryInfo.datePicker[0]
        );
        this.queryInfo.createDateEnd = dateTimes(this.queryInfo.datePicker[1]);
      } else {
        this.queryInfo.createDateStart = "";
        this.queryInfo.createDateEnd = "";
      }
      this.queryInfo.pageSize = 50;
      let data = {
        roleCode: this.queryInfo.roleCode,
        roleName: this.queryInfo.roleName,
        createDateStart: this.queryInfo.createDateStart,
        createDateEnd: this.queryInfo.createDateEnd,
        roleType: this.queryInfo.roleType,
        pageNo: this.queryInfo.pageNo, //页码
        pageSize: this.queryInfo.pageSize, //页数据
        pages: this.queryInfo.pages, //页总数据
      };
      await SysrolepageApi(data).then((res) => {
        if (res.success !== true) {
          this.$message.error("查询角色失败!");
          return;
        }
        this.$message.success("查询会员成功!");
        this.ActionroleList = res.data.list;
        this.queryInfo.pages = res.data.pages;
      });
    },
    // 操作校色定义首页列表
    async SysrolepageList() {
      if (this.queryInfo.datePicker && this.queryInfo.datePicker.length > 0) {
        this.queryInfo.createDateStart = dateTimes(
          this.queryInfo.datePicker[0]
        );
        this.queryInfo.createDateEnd = dateTimes(this.queryInfo.datePicker[1]);
      } else {
        this.queryInfo.createDateStart = "";
        this.queryInfo.createDateEnd = "";
      }
      let data = {
        roleCode: this.queryInfo.roleCode,
        roleName: this.queryInfo.roleName,
        createDateStart: this.queryInfo.createDateStart,
        createDateEnd: this.queryInfo.createDateEnd,
        roleType: this.queryInfo.roleType,
        pageNo: this.queryInfo.pageNo, //页码
        pageSize: this.queryInfo.pageSize, //页数据
        pages: this.queryInfo.pages, //页总数据
      };
      await SysrolepageApi(data).then((res) => {
        if (this.queryInfo.pageNo == 1) this.ActionroleList = [];
        this.ActionroleList = this.ActionroleList.concat(res.data.list);
        this.queryInfo.pages = res.data.pages;
        this.loading = false;
      });
    },
    load() {
      // 滑到底部时进行加载
      this.loading = true;
      setTimeout(() => {
        this.queryInfo.pageNo += 1;
        this.SysrolepageList();
      });
    },
    // 创建弹窗树节点列表
    async SysmenugetMenusApiList() {
      await SysmenugetMenusApi().then((res) => {
        this.treecontrol = res.data;
      });
    },
    // 树形勾选事件s
    checkHandler(nodeObj, SelectedObj) {
      this.treeform = SelectedObj.checkedNodes;
      console.log(this.treeform);
    },
    // 创建按钮事件
    createcz() {
      this.RoledeFormvisible = true;
      this.SysmenugetMenusApiList();
    },
    // 创建保存请求
    createList(creatrformRef) {
      let createFormcs = {
        roleCode: this.createForm.roleCode,
        roleName: this.createForm.roleName,
      };
      let item = this.$refs.tree1.getCheckedNodes();
      console.log("全选中状态", item);
      let halfCheckedKeys = this.$refs.tree1.getHalfCheckedNodes();
      halfCheckedKeys.forEach((item1) => {
        item.push(item1);
      });
      console.log("半选中状态", halfCheckedKeys);
      let createFormcsT = [];
      for (var i = 0; i < item.length; i++) {
        if (item[i].menuID !== null)
          createFormcsT.push({
            menuId: item[i].menuID,
            type: item[i].menuType,
          });
      }
      console.log("请求参数", createFormcsT);
      this.$refs[creatrformRef].validate(async (valid) => {
        if (!valid) return;
        SysroleinsertOperDefindApi(createFormcs, createFormcsT).then((res) => {
          if (res.success !== true) {
            this.$message.error("创建角色失败!");
            return;
          } else {
            this.$message.success("创建角色成功!");
            // 隐藏创建弹窗
            this.RoledeFormvisible = false;
            // 重新获取角色列表
            this.SysrolepageList();
            this.radio = "";
            this.radioValueczList = "";
          }
        });
      });
    },
    // 监听创建弹窗关闭事件
    createformClosed() {
      this.$refs.creatrformRef.resetFields();
      // this.$refs.tree.setCheckedKeys([]);
      this.treecontrol = [];
    },
    // 修改事件按钮
    modifycz() {
      if (this.radioValueczList.length == 0) {
        this.$message.warning("请选择单条数据,进行修改!");
      } else {
        this.modifycc();
        this.ModifyFormvisible = true;
      }
    },
    // 点击修改按钮将数据传给修改弹窗
    modifycc() {
      this.moifyczFormcs.roleID = this.radioValueczList.roleID;
      SysrolequeryApi(this.moifyczFormcs).then((res) => {
        this.moifyczForm = res.data;
        this.modifytree = res.data.menus;
        this.setNamexg(this.modifytree);
        console.log(this.treeform, "123123");
      });
    },
    setNamexg(modifytree) {
      //遍历树  获取id数组
      for (var i in modifytree) {
        // 如果checked不是true就不push ID
        if (modifytree[i].checked == true)
          this.xgexpandedKeys.push(modifytree[i].id); // 遍历项目满足条件后的操作
        if (modifytree[i].children) {
          //存在子节点就递归
          this.setNamexg(modifytree[i].children);
        }
      }
      this.xgxuanzhong = this.xgexpandedKeys;
      //    this.$nextTick(() => {
      //      let item = this.$refs.tree.getCheckedNodes();
      //      console.log(item)
      // });
    },
    // 修改保存请求
    modifyList(moifyformRef) {
      let modifycs = {
        roleID: this.moifyczForm.roleID,
        roleName: this.moifyczForm.roleName,
        roleCode: this.moifyczForm.roleCode,
      };
      let item = this.$refs.tree.getCheckedNodes();
      let halfCheckedKeys = this.$refs.tree.getHalfCheckedNodes();
      halfCheckedKeys.forEach((item1) => {
        item.push(item1);
        console.log("banxuanzhong", item1);
      });
      console.log("半选中状态", halfCheckedKeys);
      console.log("shuju", item);
      let modifycsT = [];
      for (var i = 0; i < item.length; i++) {
        if (item[i].menuID !== null)
          modifycsT.push({
            menuId: item[i].menuID,
            type: item[i].menuType,
          });
      }
      console.log("请求参数", modifycsT);
      this.$refs[moifyformRef].validate(async (valid) => {
        if (!valid) return;
        SysroleupdateOperDefindApi(modifycs, modifycsT).then((res) => {
          if (res.success !== true) {
            this.$message.error("修改角色失败!");
            return;
          } else {
            this.$message.success("修改角色成功!");
            // 隐藏修改弹窗
            this.ModifyFormvisible = false;
            // 重新获取角色列表
            this.SysrolepageList();
            this.radio = "";
            this.radioValueczList = "";
          }
        });
      });
    },
    // 监听修改弹窗关闭时间
    moifyformClosed() {
      this.$refs.moifyformRef.resetFields();
      this.xgexpandedKeys = [];
    },
    // 操作角色定义删除事件
    Deletecz() {
      if (this.radioValueczList.length == 0) {
        this.$message.warning("请选择单条数据,进行删除!");
      } else {
        // 获得ID
        this.deleteczqq();
        // 打开确定删除弹窗
        this.deleteFormVisible = true;
      }
    },
    // 获得id事件
    deleteczqq() {
      this.Deleteczid.roleID = this.radioValueczList.roleID;
    },
    // 确定删除弹窗确定事件
    async deleteczqd() {
      await SysroledeleteApi(this.Deleteczid).then((res) => {
        if (res.success !== true) {
          this.$message.error("删除角色失败!");
          return;
        } else {
          this.$message.success("删除角色成功!");
          // 重新获取角色列表
          this.SysrolepageList();
          this.radio = "";
          this.radioValueczList = "";
        }
      });
      // 关闭弹窗
      this.deleteFormVisible = false;
    },
    // 查看按钮事件
    lookcz() {
      if (this.radioValueczList.length == 0) {
        this.$message.warning("请选择单条数据,进行查看!");
      } else {
        // 获取id
        this.lookczid();
        // 发送请求查看记录
        SysrolequeryApi(this.lookFormcs).then((res) => {
          this.lookForm = res.data;
          this.looktree = res.data.menus;
          // 遍历树事件
          this.setName(this.looktree);
          if (res.success !== true) {
            this.$message.error("查看角色定义失败!");
            return;
          }
          this.$message.success("查看角色定义成功!");
        });
        // 打开查看弹窗
        this.LookFormvisible = true;
      }
    },
    // 查看弹窗遍历tree如果checked是true就选中
    setName(looktree) {
      //遍历树  获取id数组
      for (var i in looktree) {
        // 如果checked不是true就不push ID
        if (looktree[i].checked == true) this.expandedKeys.push(looktree[i].id); // 遍历项目满足条件后的操作
        if (looktree[i].children) {
          //存在子节点就递归
          this.setName(looktree[i].children);
        }
      }
      this.xuanzhong = this.expandedKeys;
    },
    // 获取id事件
    lookczid() {
      this.lookFormcs.roleID = this.radioValueczList.roleID;
    },
    // 监听查看弹框关闭事件
    lookformClosed() {
      this.$refs.lookformRef.resetFields();
      this.expandedKeys = [];
    },
    // 查看弹窗tree 全部为禁用
    disabledFn() {
      return true;
    },
    // radio选中获取首页列表数据
    ActionroleRadioChange(value) {
      this.radioValueczList = value;
      console.log(this.radioValueczList);
    },
    // 判断如果是单行就变黄色双行是白色
    tableRowClassName({ rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "warning-row";
      }
      return "";
    },
  },
};
</script>
<style lang="scss" scoped>
// #alterations {
//   height: 100%;
// }
.header-text {
  height: 50px;
  margin-top: 20px;
  color: #76734f;
}
.searchform {
  margin-top: 20px;
}
.centercard {
  margin-top: 10px;
}
.card-pagination {
  margin-top: 20px;
  text-align: right;
}
// 按钮边框去掉，文字颜色和加粗
/deep/button {
  border-color: #e6e0af;
  border-radius: 7px;
  color: #a19b59;
}
/deep/input {
  border-radius: 0 !important;
}
// 去除表头复选框
/deep/.table-style {
  .el-table-column--selection.is-leaf .el-checkbox {
    display: none;
  }
}

.el-table .warning-row {
  background: #fcfbf2;
}

.el-table .success-row {
  background: #ffffff;
}
::v-deep {
  .el-table .warning-row {
    background: #fcfbf2;
  }

  .el-table .success-row {
    background: #ffffff;
  }
  // 改变table里的按钮图标大小
  .table-button .iconfont {
    font-size: 14px;
  }
  // 改变分页背景色
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #d1cda5 !important;
    color: #ffffff !important;
  }
  // 改变分页字体颜色
  .el-pagination.is-background .btn-next,
  .el-pagination.is-background .btn-prev,
  .el-pagination.is-background .el-pager li {
    color: #d1cda5 !important;
  }

  // 设置表单里字体的颜色
  .el-form-item__label {
    color: #76734f;
  }
  // 创建弹窗样式
  .found {
    .el-dialog__header {
      background-color: #f3f1dd;
    }
    .el-dialog__title {
      font-size: 14px;
      font-weight: 700;
      color: #6c6937;
    }

    .el-dialog__footer {
      height: 60px;
      background-color: #f2f2f2;
    }
    .el-textarea__inner {
      // 取消拉伸样式
      resize: none;
    }
  }
  // 创建弹窗标题栏
  .menutitle {
    height: 40px;
    // border: 1px solid #000;
    background-color: #f3f1dd;
    position: relative;
  }
  .titlewz {
    position: absolute;
    top: 50%;
    transform: translate(10%, -50%);
    font-size: 0.875rem;
    color: #6c6937;
  }
  // 删除弹框样式
  .delete {
    .el-dialog__header,
    .el-message-box__header {
      border-top-left-radius: 9px;
      border-top-right-radius: 9px;
      height: 44px;
      background: #f3f1dd;
      width: 100%;
      text-align: center;
      color: #666;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 20px;
      box-sizing: border-box;
    }
    .el-dialog__title,
    .el-message-box__title {
      color: #6c6937;
      font-weight: 700;
      font-size: 16px !important;
    }
    .el-dialog .el-dialog__body {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .coverage-release .el-dialog__body {
      padding: 20px;
    }
    .el-button:hover {
      background-color: #b6b388;
    }
    .el-dialog__body {
      padding: 30px 60px;
    }
    .el-tabs__item {
      border: 1px solid #d9d9d9;
      background-color: #fff;
      color: #6c6937;
    }
    .el-dialog__footer {
      height: 60px;
      text-align: center;
      background-color: #f2f2f2;
    }

    .el-tabs__item.is-active {
      color: #6c6937;
      background-color: #f3f1dd;
    }
    .el-form-item__content {
      line-height: 0px;
    }
    .el-textarea__inner {
      // 取消拉伸样式
      resize: none;
    }
  }
  // 查看弹窗样式
  .look {
    .el-dialog__header {
      background-color: #f3f1dd;
    }
    .el-dialog__title {
      font-size: 14px;
      font-weight: 700;
      color: #6c6937;
    }

    .el-dialog__footer {
      height: 60px;
      background-color: #f2f2f2;
    }
    .el-textarea__inner {
      // 取消拉伸样式
      resize: none;
    }
  }
}
</style>
